import { Locale } from '../types';

export function parseLocale(locale?: string | null): Locale {
  if (!locale) {
    return Locale.nl;
  }

  const lowercaseLocale = locale.toLowerCase();

  if (!(lowercaseLocale in Locale)) {
    return Locale.nl;
  }

  return lowercaseLocale as Locale;
}
